import { createReducer } from "@reduxjs/toolkit";
import initStates from "./initStates";
import {
  CATEGORYVIEW_TOP_REQUEST_ACTION,
  CHECK_SELLER_CHOICE_EXPIRATION_ACTION,
  FETCHING_SELLER_ACTION,
  FETCHING_SELLER_ERROR_ACTION,
  FETCHING_SELLER_SUCCESS_ACTION,
  RESET_SELLER_CHOICE_ACTION,
  SET_SELLER_CHOICE_ACTION,
  setHasOfflineProducts,
  setOfflineAvailableSellers,
} from "_redux/actions/catalog";
import { constants } from "@hcl-commerce-store-sdk/utils";
import { localStorageUtil } from "_foundationExt/utils/storageUtil";
import {
  getExpirationUntilMidnightInDays,
  getNextMidnightTimeInMS,
} from "tools/timeUtils";

const catalogReducer = createReducer(initStates.catalog, (builder) => {
  builder.addCase(CATEGORYVIEW_TOP_REQUEST_ACTION, (state, action) => {
    const { payload } = action;
    const categoryTop = payload?.data?.catalogGroupView || [];
    Object.assign(state, { categoryTop });
  });

  builder
    .addCase(FETCHING_SELLER_ACTION, (state) => {
      state.sellerLoading = true;
    })
    .addCase(FETCHING_SELLER_SUCCESS_ACTION, (state, action) => {
      const { payload } = action;
      state.seller = payload?.seller ?? [];
      state.sellerLoading = false;
    })
    .addCase(FETCHING_SELLER_ERROR_ACTION, (state, action) => {
      state.seller = [];
      state.sellerLoading = false;
    })
    .addCase(SET_SELLER_CHOICE_ACTION, (state, action) => {
      const expirationTimeInDays = getExpirationUntilMidnightInDays();
      const expiresAt = getNextMidnightTimeInMS();

      state.sellerChoice = {
        sellerId: action.payload,
        expiresAt,
      };

      localStorageUtil.set(
        constants.SELECTED_SELLER,
        action.payload,
        expirationTimeInDays
      );
    })
    .addCase(CHECK_SELLER_CHOICE_EXPIRATION_ACTION, (state, action) => {
      // redux part
      if (
        state.sellerChoice?.expiresAt &&
        Date.now() >= state.sellerChoice.expiresAt
      ) {
        delete state.sellerChoice;
      }
      // localStorage part
      localStorageUtil.invalidateIfExpired(constants.SELECTED_SELLER);
    })
    .addCase(RESET_SELLER_CHOICE_ACTION, (state, action) => {
      delete state.sellerChoice;
      localStorageUtil.remove(constants.SELECTED_SELLER);
    })
    .addCase(setHasOfflineProducts, (state, { payload }) => {
      state.hasOfflineProducts = payload;
    })
    .addCase(setOfflineAvailableSellers, (state, { payload }) => {
      state.offlineAvailableSellers = payload;
    });
});
export default catalogReducer;
